import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { ESRS, ESRSService } from 'src/app/services/ESRS/esrs.service';
import { Impatto } from 'src/app/services/impatto/impatto.service';
import { DialogSelezionaImpattiDdComponent } from '../dialog-seleziona-impatti-dd/dialog-seleziona-impatti-dd.component';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { DialogRef } from '@angular/cdk/dialog';
import { finalize } from 'rxjs';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'app-dialog-crea-esrs',
  standalone: false,

  templateUrl: './dialog-crea-esrs.component.html',
  styleUrl: './dialog-crea-esrs.component.scss',
})
export class DialogCreaESRSComponent implements OnInit, AfterViewInit {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;
  @ViewChildren('inputDesc', { read: CdkTextareaAutosize })
  queryListTextareaDescrizone!: QueryList<CdkTextareaAutosize>;
  @ViewChildren('inputCodice', { read: CdkTextareaAutosize })
  queryListTextareaCodice!: QueryList<CdkTextareaAutosize>;

  public esrsFormGroup!: FormGroup;
  public esrsData: ESRS | undefined = undefined;
  public arrayImpattiSel: Impatto[] = [];

  constructor(
    private readonly fb: FormBuilder,
    public dialog: MatDialog,
    private readonly dialogRef: DialogRef<DialogCreaESRSComponent>,
    private readonly esrsService: ESRSService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      esrs: ESRS;
    },
  ) {}

  ngOnInit(): void {
    this.esrsData = this.data.esrs;

    this.esrsFormGroup = this.creaStrutturaAnnidata(this.fb, this.esrsData);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.queryListTextareaDescrizone?.forEach((area) => area.resizeToFitContent(true));
      this.queryListTextareaCodice?.forEach((area) => area.resizeToFitContent(true));
    }, 0);
  }

  /**
   * Spostamento degli elementi con il drop
   * @param event
   * @param formArraySottoTemi array sul quale fare lo spostamento
   */
  dropElementi(event: CdkDragDrop<any[]>, formArraySottoTemi: FormArray) {
    const currentGroup = formArraySottoTemi.at(event.previousIndex);
    formArraySottoTemi.removeAt(event.previousIndex);
    formArraySottoTemi.insert(event.currentIndex, currentGroup);
  }

  /**
   * Eliminazione di un elemento dal array
   * @param formArrayRisposte array dal quale eliminare l'elemento
   * @param index posizione del elemento da eliminare
   */
  eliminaElemento(formArrayRisposte: FormArray, index: number) {
    formArrayRisposte.removeAt(index);
  }

  /**
   * Metodo che mi crea una struttura oggetto annidata
   * Si ferma al 3 livello ovvero (sotto sotto temi)
   * @param formBuilder per creare i formGroup / Array / Control
   * @param tema oggetto tema che mi arriva dal esterno. Serve anche per creare l'annidamento successivo
   * @param livello livello di struttura al quale fermarsi
   * @returns form group di un tema annidato
   */
  creaStrutturaAnnidata(
    formBuilder: FormBuilder,
    tema: ESRS | undefined,
    livello: number = 3,
  ): FormGroup {
    if (livello === 0) {
      return formBuilder.group({});
    }

    return formBuilder.group({
      id: [tema?.id ?? ''],
      nomeBreve: [tema?.nomeBreve ?? '', Validators.required],
      descrizione: [tema?.descrizione ?? ''],
      impatti: formBuilder.array(
        tema?.impatti && tema.impatti.length > 0
          ? tema.impatti.map((imp: Impatto) => this.creaFGImpatti(imp))
          : [],
      ),

      sottoTemi: formBuilder.array(
        tema?.sottoTemi && tema.sottoTemi.length > 0
          ? tema.sottoTemi.map((st) => this.creaStrutturaAnnidata(formBuilder, st, livello - 1))
          : /* livello > 1 ? [this.creaStrutturaAnnidata(formBuilder, undefined, livello - 1)] : */ [],
      ),
    });
  }

  /**
   * Metodo che mi crea un form control per ogni impatto e poi lo aggiunge ad un formGroup
   * @param figlio
   * @returns form group di impatti
   */
  creaFGImpatti(impatto: Impatto): FormGroup {
    const groupConfig: { [key: string]: any } = {};

    Object.entries(impatto).forEach(([key, value]) => {
      groupConfig[key] = new FormControl(value);
    });

    return this.fb.group(groupConfig);
  }

  /**
   * Apre la dialog per la selezione di impatti
   * @param formImpatti
   */
  apriSelezioneImpatti(formImpatti: FormArray) {
    this.getArrayImpattiSelezionati(formImpatti);

    const dialogCfgRisposteTematica = this.dialog.open(DialogSelezionaImpattiDdComponent, {
      data: {
        arraySelezioinati: this.arrayImpattiSel,
      },
      panelClass: ['dialog-container-scrollbar'],
      disableClose: false,
      width: '80%',
      maxHeight: '70%',
      height: '100%',

      autoFocus: false,
    });

    dialogCfgRisposteTematica.afterClosed().subscribe((result) => {
      if (result) {
        this.mappaImpattidaEsterno(result, formImpatti);
      }
    });
  }

  /**
   * Mi valorizza l'array degli imatti selezionati
   * Mi serve per la selezione degli impatti per poter filtrare quelli già selezionati
   * @param formImpatti
   */
  getArrayImpattiSelezionati(formImpatti: FormArray) {
    this.arrayImpattiSel = [];
    if (formImpatti.getRawValue().length) {
      this.arrayImpattiSel.push(...formImpatti.getRawValue());
    }
  }

  /**
   * Mi mappo nel oggetto corretto i kpi selezionate nella configurazione risposta
   * @param opzione
   * @param formImpatti
   */
  public mappaImpattidaEsterno(impatti: Impatto[], formImpatti: FormArray) {
    formImpatti.clear();
    Object.entries(impatti).forEach(([key, value]) => {
      formImpatti.controls.push(new FormControl(value));
    });
  }

  /**
   * Aggiunta di un nuovo sotto tema
   */
  addSottoTema() {
    const sottoTemiArray = this.esrsFormGroup.get('sottoTemi') as FormArray;
    /*   const idTema = this.esrsFormGroup.get('id')?.value */
    sottoTemiArray.push(
      this.fb.group({
        id: [null],
        nomeBreve: ['', Validators.required],
        descrizione: [''],
        impatti: this.fb.array([]),
        sottoTemi: this.fb.array([]),
      }),
    );
  }

  /**
   * Aggiunta di un nuovo sotto sotto tema
   */
  addSottoSottoTema(sottoSottoTema: FormArray) {
    /*     const idTema = this.esrsFormGroup.get('id')?.value */

    sottoSottoTema.push(
      this.fb.group({
        id: [null],
        nomeBreve: ['', Validators.required],
        descrizione: [''],
        impatti: this.fb.array([]),
        sottoTemi: this.fb.array([]),
      }),
    );
  }

  /**
   * Metodo di salvataggio esrs
   */
  salva() {
    if (!this._isFormValid()) {
      return;
    }

    const esrs: ESRS = this.esrsFormGroup.getRawValue();

    if (esrs.id) {
      this.spinnerOver.show();
      this.esrsService
        .putEsrs(esrs.id, esrs)
        .pipe(finalize(() => this.spinnerOver.hide()))
        .subscribe({
          next: (esito) => {
            this.dialogRef.close();
          },
          error: (err) => {
            console.error(err);
          },
        });
    } else {
      this.spinnerOver.show();
      this.esrsService
        .postEsrs(esrs)
        .pipe(finalize(() => this.spinnerOver.hide()))
        .subscribe({
          next: (esito) => {
            this.dialogRef.close();
          },
          error: (err) => {
            console.error(err);
          },
        });
    }
  }

  private _isFormValid(): boolean {
    if (this.esrsFormGroup.valid) {
      return true;
    }

    // TEMA
    Object.values(this.esrsFormGroup.controls).forEach((campoTema) => {
      campoTema.markAsTouched();
    });

    // SOTTO TEMA
    Object.values((this.esrsFormGroup.controls['sottoTemi'] as FormGroup).controls).forEach(
      (sottoTema) => {
        // CAMPI - SOTTO TEMA
        Object.values((sottoTema as FormGroup).controls).forEach((campoSottoTema) => {
          campoSottoTema.markAsTouched();
        });

        // SOTTO SOTTO TEMA
        Object.values(
          ((sottoTema as FormGroup).controls['sottoTemi'] as FormGroup).controls,
        ).forEach((control) => {
          // CAMPI SOTTO SOTTO TEMA
          Object.values((control as FormGroup).controls).forEach((campoSottoSottoTema) => {
            campoSottoSottoTema.markAsTouched();
          });
        });
      },
    );

    return false;
  }
}
